import { createMailing } from './createMailing';
import { createMarketingAnalyticsPhoneNumber } from './createMarketingAnalyticsPhoneNumber';
import { fetchMarketingAnalyticsPhoneNumbers } from './fetchMarketingAnalyticsPhoneNumbers';
import { fetchReferrals } from './fetchReferrals';
import { generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl } from './generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl';
import { getMailings } from './getMailings';
import { sendMarketingEmail } from './sendMarketingEmail';
import { sendPromotionEmailOrSms } from './sendPromotionEmailOrSms';
import { updateMarketingAnalyticsPhoneNumber } from './updateMarketingAnalyticsPhoneNumber';

export const marketingService = {
  createMailing,
  createMarketingAnalyticsPhoneNumber,
  fetchMarketingAnalyticsPhoneNumbers,
  fetchReferrals,
  generateMarketingAnalyticsPhoneNumberMediaUploadPresignedUrl,
  getMailings,
  sendMarketingEmail,
  sendPromotionEmailOrSms,
  updateMarketingAnalyticsPhoneNumber,
};
